// userTypes.js — dashboard / portfolio data for the signed-in user

export const USER_PORTFOLIO_REQUEST = "USER_PORTFOLIO_REQUEST";
export const USER_PORTFOLIO_SUCCESS = "USER_PORTFOLIO_SUCCESS";
export const USER_PORTFOLIO_FAILURE = "USER_PORTFOLIO_FAILURE";

export const USER_CLEAR = "USER_CLEAR";
